import { Badge, Spinner, Table } from 'react-bootstrap';
import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { Questionnaire, QuestionnaireStatus } from '../../../infrastructure/QuestionnaireClient';
import { ROUTES } from '../../../routes/routes';

interface SurveyListProps {
  surveys: Questionnaire[];
  isLoading: boolean;
}

const statusVariant = (status: QuestionnaireStatus): string => {
  if (status === 'published') return 'success';
  if (status === 'archived') return 'secondary';
  return 'warning';
};

export function SurveyList({ surveys, isLoading }: SurveyListProps) {
  return (
    <section className="border rounded p-3 bg-white">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="h5 mb-0">Surveys</h2>
        {isLoading && <Spinner animation="border" size="sm" />}
      </div>
      <Table responsive hover size="sm" className="align-middle mb-0">
        <thead>
          <tr>
            <th>Survey</th>
            <th>Status</th>
            <th>Version</th>
            <th>Answers</th>
            <th aria-label="Actions" />
          </tr>
        </thead>
        <tbody>
          {surveys.map((survey) => (
            <tr key={survey.id}>
              <td>
                <div className="fw-semibold">{survey.title}</div>
                <div className="text-muted small font-monospace">{survey.surveyUuid}</div>
              </td>
              <td>
                <Badge bg={statusVariant(survey.status)}>{survey.status}</Badge>
              </td>
              <td>{survey.latestVersion?.version ?? '-'}</td>
              <td>{survey.responseCount ?? '-'}</td>
              <td className="text-end">
                <Link
                  className="btn btn-outline-secondary btn-sm"
                  to={ROUTES.survey.settings(survey.id)}
                  aria-label={`Open ${survey.title}`}
                >
                  <Eye size={15} />
                </Link>
              </td>
            </tr>
          ))}
          {!isLoading && surveys.length === 0 && (
            <tr>
              <td colSpan={5} className="text-muted py-4 text-center">
                No surveys
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </section>
  );
}
